<template>
  <dl class="border border-gray-200 p-4 md:pt-5 md:px-6 md:pb-6 rounded-lg flex flex-col gap-4 text-gray-800">
    <DetailRow
      icon="speaker"
      label="Audio:"
    >
      <span
        class="w-2/3 lg:w-4/5"
        v-text="lesson.hasAudio ? 'Yes' : 'No'"
      />
    </DetailRow>
    <DetailRow
      v-if="lesson.language"
      icon="globe"
      label="Language:"
    >
      <span
        v-text="lesson.language"
      />
    </DetailRow>
    <DetailRow 
      v-if="lesson.topicTags.length"
      icon="grid-2"
      label="Topics:"
    >
      <a
        v-for="topic in lesson.topicTags"
        :key="topic"
        :href="searchUrl(RecordType.Lesson, { topicTags: topic })"
        class="link link--blue underline font-normal block after:content-[','] last:after:content-none"
      >
        {{ topic }}
      </a>
    </DetailRow>
    <DetailRow 
      v-if="lesson.themeTags.length"
      icon="masks-theater"
      label="Themes:"
    >
      <a
        v-for="theme in lesson.themeTags"
        :key="theme"
        :href="searchUrl(RecordType.Lesson, { themeTags: theme })"
        class="link link--blue underline font-normal block after:content-[','] last:after:content-none"
      >
        {{ theme }}
      </a>
    </DetailRow>
    <DetailRow
      v-if="lesson.grammarTags.length"
      icon="comment"
      label="Grammar:"
    >
      <a 
        v-for="grammar in lesson.grammarTags"
        :key="grammar"
        :href="searchUrl(RecordType.Lesson, { grammarTags: grammar })"
        class="link link--blue underline font-normal block after:content-[','] last:after:content-none"
      >
        {{ grammar }}
      </a>
    </DetailRow>
    <DetailRow
      v-if="lesson.tenseTags.length"
      icon="layer-group"
      label="Levels:"
    >
      <a
        v-for="tense in lesson.tenseTags"
        :key="tense"
        :href="searchUrl(RecordType.Lesson, { tenseTags: tense })"
        class="link link--blue underline font-normal block after:content-[','] last:after:content-none"
      >
        {{ tense }}
      </a>
    </DetailRow>
    <!-- Todo Path always missing -->
    <DetailRow 
      v-if="lesson.path"
      icon="signs-post"
      label="Path:"
    >
      <a
        :href="`/paths/${lesson.path.uuid}`"
        class="link link--blue underline font-normal"
      >
        {{ lesson.path.title }}
      </a>
    </DetailRow>
  </dl>
</template>

<script lang="ts">
export default { name: 'DetailList' }
</script>

<script setup lang="ts">
import { searchUrl } from '~/lib/url'

import { RecordType } from '~/types/records/RecordType'
import { LessonRecord } from '~/types/records/LessonRecord'

import DetailRow from '~/components/externalContent/DetailRow.vue'

defineProps<{
  lesson: LessonRecord,
}>()
</script>
